import React from 'react';
import SocialMediaIcons from '../../dashboardNew/components/social/SocialMediaIcons'
import Anchor from "../objects/Anchor";

const BannerAdverts = props => {

    const {image, heading, bodyCopy, ctaCopy, ctaLink, altStyle} = props;

    const social = [
        {name: 'facebook', url: 'https://www.facebook.com/'},
        {name: 'twitter', url: 'https://www.twitter.com/'},
        {name: 'linkedin', url: 'https://www.linkedin.com/'},
        {name: 'youtube', url: 'https://www.youtube.com/'},
    ];

    const alt = altStyle === true ? 'alternative switch' : '';

    return (
        <div className={`container-fluid full-width-info-image ${alt}`}>
            <div className="container">
                <div className="row">
                    <div className="col-12 col-lg-6 inner-content inner-image">
                        <div className="image" style={{backgroundImage: `url(${image})`}}></div>
                    </div>
                    <div className="col-12 col-lg-6 inner-content inner-info">
                        <h3 className="heading-main">{heading}</h3>
                        <p className="body-copy">{bodyCopy}</p>
                        <Anchor path={ctaLink} anchorClass={'theme-button'} internal>
                            {ctaCopy}
                        </Anchor>
                        {/*Feature for future*/}
                        {/*<div className="social-hold">*/}
                        {/*    <SocialMediaIcons social={social}/>*/}
                        {/*</div>*/}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BannerAdverts;


// WEBPACK FOOTER //
// src/client/components/dashboardNew/components/BannerAdverts.js